module.exports = __webpack_public_path__ + "static/wellBeing.jpg";